import { TankStock } from "../models/TankStock";

export const generateBunkers = (report) => {

    if (!report.bunker.bdn_based_reporting_bunkered_fuels || report.bunker.bdn_based_reporting_bunkered_fuels.length == 0) {
        try {
            report.bunker.bdn_based_reporting_bunkered_fuels = [
                new TankStock(),
                new TankStock(),
                new TankStock()
            ]
        } catch (err) {
            console.error(err)
        }
    } else {
        report.bunker.bdn_based_reporting_bunkered_fuels = report.bunker.bdn_based_reporting_bunkered_fuels.map(a => new TankStock(a))
    }
}

export const generateBlendBunkers = (report) => {
    const newComponent1 = new TankStock()
    const newComponent2 = new TankStock()

    newComponent1.is_component_of_blend = true;
    newComponent2.is_component_of_blend = true;
    
    report.bunker.new_blend_components = [
        newComponent1,
        newComponent2
    ]
        try {
            report.bunker.bdn_based_reporting_bunkered_fuels = [
            ...report.bunker?.bdn_based_reporting_bunkered_fuels, 
            ...report.bunker.new_blend_components
        ];
        } catch (err) {
            console.error(err)
        }
}